import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card'

interface AdminSectionCardProps {
  title: string
  description?: string
  children: React.ReactNode
  footer?: React.ReactNode
  className?: string
}

export function AdminSectionCard({ title, description, children, footer, className }: AdminSectionCardProps) {
  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description ? <CardDescription>{description}</CardDescription> : null}
      </CardHeader>
      <CardContent>{children}</CardContent>
      {footer ? <div className="border-t px-6 py-4">{footer}</div> : null}
    </Card>
  )
}
